import { useEffect, useState } from "react";

/**
 * useMediaQuery — small hook returning true when the given CSS media query
 * matches. Re-renders on viewport changes.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    mql.addEventListener ? mql.addEventListener("change", handler) : mql.addListener(handler);
    setMatches(mql.matches);
    return () => {
      mql.removeEventListener ? mql.removeEventListener("change", handler) : mql.removeListener(handler);
    };
  }, [query]);
  return matches;
}

/**
 * useIsDesktop — Msg 251 · desktop breakpoint. True for ≥1024px viewports.
 * Everything below that is a phone / small-tablet layout.
 */
export function useIsDesktop() {
  return useMediaQuery("(min-width: 1024px)");
}
